const VALET_URL = 'https://valet.parkoye.com'

// const UNORGANISED_URL = 'https://api.parkoye.com'
// const UNORGANISED_URL = 'http://10.0.0.19:8080'
const UNORGANISED_URL = 'http://172.20.10.3:8080'

export { VALET_URL, UNORGANISED_URL }
